import React, { useState, useEffect } from "react";
import { Container, Typography, Paper, Dialog } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getClients, deleteClient } from "../../services/firestore";
import ClientForm from "../../components/ClientForm";

// PCS Admin React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// PCS Admin React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function Clients() {
  const [rows, setRows] = useState([]);
  const [selected, setSelected] = useState(null);
  const [openForm, setOpenForm] = useState(false);

  const loadClients = async () => {
    try {
      const clients = await getClients();
      setRows(clients);
    } catch (error) {
      console.error("Error al cargar clientes:", error);
    }
  };

  useEffect(() => {
    loadClients();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("¿Está seguro de eliminar este cliente?")) {
      try {
        await deleteClient(id);
        loadClients();
      } catch (error) {
        console.error("Error al eliminar cliente:", error);
      }
    }
  };

  const columns = [
    { field: "nombre", headerName: "Nombre", flex: 1 },
    { field: "email", headerName: "Correo", flex: 1 },
    { field: "telefono", headerName: "Teléfono", flex: 1 },
    { field: "direccion", headerName: "Dirección", flex: 1 },
    {
      field: "actions",
      headerName: "Acciones",
      flex: 1,
      renderCell: (params) => (
        <MDBox>
          <MDButton
            variant="gradient"
            color="info"
            size="small"
            onClick={() => {
              setSelected(params.row);
              setOpenForm(true);
            }}
            sx={{ mr: 1 }}
          >
            Editar
          </MDButton>
          <MDButton
            variant="gradient"
            color="error"
            size="small"
            onClick={() => handleDelete(params.row.id)}
          >
            Eliminar
          </MDButton>
        </MDBox>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Container maxWidth="lg">
          <MDBox sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Typography variant="h4">Clientes</Typography>
            <MDButton
              variant="gradient"
              color="info"
              onClick={() => {
                setSelected(null);
                setOpenForm(true);
              }}
            >
              Nuevo Cliente
            </MDButton>
          </MDBox>

          <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10]}
              autoHeight
              disableSelectionOnClick
            />
          </Paper>

          <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="sm" fullWidth>
            <MDBox sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                {selected ? "Editar Cliente" : "Nuevo Cliente"}
              </Typography>
              <ClientForm
                initialValues={selected || {}}
                onSaved={() => {
                  setOpenForm(false);
                  loadClients();
                }}
              />
            </MDBox>
          </Dialog>
        </Container>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Clients;
